import { GroupBy } from './types';

export const groupByOptions: GroupBy[] = [
  { type: 'Location', title: 'Location' },
  { type: 'ItemNumber', title: 'Item Number' },
];
